<template>
    <div>
        <div class="popup__content">
            <div class="text-size-l text-bold text-color mb24">Группа пользователей</div>
            <div class="add-cat-uppercase" style=" width: 100%;">
                <input-styled
                :auto-focus="true"
                name="staff-group"
                :placeholder="'Название'"
                :placeholderInput="'Название'"
                @enter="send"
                v-model="form.category.text"
                @focus="form.category.error=false"
                :is-error="form.category.error">
                </input-styled>
            </div>
            <div class="row-b mt24">
                <div class="row-b__col elem-pos-fix mr24">
                    <submit-btn class="" @click.native="send" :type="form.btnType">
                        <span class="i i-ok7 mr8"></span>Сохранить
                    </submit-btn>
                </div>
            </div>
            <div v-if="editGroup.id" class="remove-rule" @click="removeCat(editGroup.id)" >
                <a href="javascript:void(0);" class="link-icon link-icon__modal">
                    <span class="i i-trash2"></span>
                    <span class="text">Удалить группу</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import InputStyled from '@/components/forms/InputStyled.vue';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue'
    import {scrollTo} from '@/helpers/animate.js';

    export default {
        name: "ContactGroup",
        components: {
            InputStyled,
            SubmitBtn
        },
        mounted(){
            //if(this.section && this.section.length>0){
                this.form.category.text = this.editGroup.name;
            //}
        },
        data() {
            return {
                form:{
                    category: {
                        text: '',
                        error: false,
                    },
                    btnType: 'normal'
                },
            }
        },
        methods: {
            removeCat: function(id){
                this.$store.dispatch('contacts/removeGroup', {id: id,})
                    .then(result => {
                        this.$store.commit('popups/close', {name: this.popups.staffGroup.name});
                        if(result){
                            this.$store.commit('popups/close', {name: this.popups.staffGroup.name});
                        }
                        else{
                            this.openRemoveStaffGroupError();
                        }
                    });
            },
            openRemoveStaffGroupError: function () {
                this.$store.commit('popups/open', {name: this.popups.removeContactGroupError.name});
            },
            send(){
                let error = false;
                if(!this.form.category.text || this.form.category.text.length == 0){
                    if(this.form.category.error){
                        this.form.category.error = false;
                        setTimeout(() => {
                            this.form.category.error = true;
                        }, 10);
                    }else{
                        this.form.category.error = true;
                    }
                    error = true;
                }
                if(!error){
                    this.form.btnType = 'load';
                    this.$store.dispatch('contacts/setGroup', {
                        name: this.form.category.text,
                        id: this.editGroup.id ? this.editGroup.id : false,
                    }).then(()=>{
                        this.form.btnType = 'normal';
                        this.$store.commit('popups/close', {name: this.popups.staffGroup.name});
                        // На всякий случай очистим данные для редактирования раздела
                        this.$store.commit('contacts/setEditGroup',[]);
                    });
                }
            },
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                editGroup: state => state.contacts.editGroup,
            }),
        },
    }
</script>

<style scoped>

</style>
